export default __webpack_public_path__ + "static/media/Akanksha Dixit Outreach Team Lead.9a3d37e8.jpg";